import { connect } from 'react-redux';
import { getSelectedFacets, getFacets, getLocationBreadcrumb, setLocationBreadcrumb, getKeywords} from '../../../modules/Filters';
import { getBase } from '../../../modules/Settings';
import { clearTagFromUrl, addDontMappFacet, buildNewQueryString, updateUrl } from '../../../app/helpers';
import { FacetDropdownSelect } from './FacetDropdown';

const mapStateToProps = state => ({
  selectedFacets: getSelectedFacets(state),
  facets: getFacets(state),
  keywords: getKeywords(state),
  base: getBase(state),
  locationBreadcrumb: getLocationBreadcrumb(state)
});

const removeChildren = (selected, key, value, location) => {
  let returnLocation = location;
  [].concat(selected.value).filter(v => v.indexOf(key + '2:' + value) === 0).forEach(v => {
    const childValue = v.split(':').pop();
    returnLocation = clearTagFromUrl(returnLocation, {name: key, value: childValue});
    const mappingInfo = selected.mappedFrom.find( o => o.val.toLowerCase() === childValue.toLowerCase() && o.mappedFrom);
    if (mappingInfo) returnLocation = addDontMappFacet(returnLocation, mappingInfo.mappedFrom);
  });
  return returnLocation;
};

const mapCallbacksToProps = dispatch => ({
  changeValue: (value, { key, groupLabel, push, facets, base: { pathname, qs }, locationBreadcrumb}, selected, keywords, remove) => {
    window._mz && window._mz.setReferrerData({ module: groupLabel, id: value });
    const encKey = encodeURIComponent(key);

    // This is a horrible piece of code, but the rationale behind it is:
    // When sending excludedLocations, we want to include the full "facetItemPath", i.e
    // Europe:United Kingdom:London as opposed to to just "London"
    // But, we can't just remove the `split`, so we've decided that as a temporary measure
    // that for excludedLocations only, we will not split, this should mean there are no unintended concequences
    const decodedValue = encKey === "excludedLocations" ? decodeURIComponent(value) : decodeURIComponent(value).split(':').pop();

    const newUri = updateUrl(qs, keywords);
    if (key === 'locations') {
      const selectedLevel = value.split(':').length;
      if (selectedLevel > locationBreadcrumb.length) {
        locationBreadcrumb.push(facets[key]);
        dispatch(setLocationBreadcrumb(locationBreadcrumb));
      } else {
        dispatch(setLocationBreadcrumb(locationBreadcrumb.slice(0, selectedLevel)));
      }
      return push({
        pathname,
        search: buildNewQueryString('locations', decodedValue, newUri),
        state: {
          notScroll: true
        }
      });
    }


    const newUriPart = `${encKey}=${encodeURIComponent(decodedValue)}`;
    let newLocation = '';
    if (!remove) {
      newLocation = (newUri.indexOf('?') > -1
        ? newUri.concat(`&${newUriPart}`)
        : newUri.concat(`?${newUriPart}`));
    }

    if (remove) {
      newLocation = clearTagFromUrl(newUri, {name: key, value});
      const mappingInfo = (selected.mappedFrom || []).find( o => o.val.toLowerCase() === value.toLowerCase() && o.mappedFrom);
      if (mappingInfo) newLocation = addDontMappFacet(newLocation, mappingInfo.mappedFrom);
      newLocation = removeChildren(selected, key, value, newLocation);
    }
    push({
      pathname,
      search: (newLocation) ? newLocation : newUri,
      state: {
        notScroll: true
      }
    });
  }
});

export const FacetDropdown = connect(mapStateToProps, mapCallbacksToProps)(FacetDropdownSelect);

